export const SERVICE = 'CONFIG'
